export default __webpack_public_path__ + "static/media/parcela_6.a911c875.png";